import React from 'react';

const TOTAL_PHASES = 4;

function PhaseProgressBar({ progress = 0 }) {
  console.log('[Progress Debug] PhaseProgressBar received progress:', progress);
  const boundedProgress = Math.max(0, Math.min(100, Number(progress) || 0));

  // Calculate completed phases (X) out of total phases (Y)
  void Math.min(TOTAL_PHASES, Math.ceil(boundedProgress / 25));
  
  // Interpolate color from red to green based on progress
  // Red at 0%: rgb(239, 68, 68)
  // Green at 100%: rgb(34, 197, 94)
  const interpolateColor = (value) => {
    const red = { r: 239, g: 68, b: 68 };
    const green = { r: 34, g: 197, b: 94 };
    
    const ratio = value / 100;
    const r = Math.round(red.r + (green.r - red.r) * ratio);
    const g = Math.round(red.g + (green.g - red.g) * ratio);
    const b = Math.round(red.b + (green.b - red.b) * ratio);
    
    return `rgb(${r}, ${g}, ${b})`;
  };
  
  const barColor = interpolateColor(boundedProgress);

  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 min-w-[80px]">
        <div className="h-2 w-full overflow-hidden rounded-full bg-gray-700">
          <div
            className="h-full rounded-full transition-all duration-300"
            style={{ 
              width: `${boundedProgress}%`,
              backgroundColor: barColor
            }}
          />
        </div>
      </div>
      <span className="text-xs text-gray-300 whitespace-nowrap">
        {boundedProgress}%
      </span>
    </div>
  );
}

export default PhaseProgressBar;
